export default {"src":"/_next/static/media/shopify.736fc583.svg","height":60,"width":213,"blurWidth":0,"blurHeight":0};